module.exports = __webpack_public_path__ + "static/media/Alicia P.651aea94.jpeg";